import constants from "../../core/constants";
import map from "lodash/fp/map";
import head from "lodash/fp/head";
import isNil from "lodash/fp/isNil";
import capitalize from "lodash/fp/capitalize";
import moment from "moment";
import { parsePrice } from "../../core/utils";

class LoansPageTransform {
  constructor() {
    "ngInject";

    this.fields = [
      { name: "captain", title: "Captain" },
      { name: "type", title: "Type" },
      { name: "total_amount", title: "Total amount" },
      { name: "remaining_amount", title: "Remaining amount" },
      { name: "installments_count", title: "Installments Count" },
      { name: "installments_interval", title: "Installments interval" },
      { name: "next_installments", title: "Upcoming Installment" },
      { name: "upcomingInstallments", title: "Upcoming amount" },
      { name: "createdAt", title: "Created At" },
      { name: "isFinalized", title: "Finalized" },
    ];
  }

  justify(data) {
    const format = (item) => {
      item.type = capitalize(item.type);
      item.createdAt = moment(item.createdAt).format(constants.dateFormat);
      item.upcomingInstallments =
        item.next_installments.length > 0
          ? head(item.next_installments).amount
          : null;
      item.next_installments =
        item.next_installments.length > 0
          ? moment(head(item.next_installments).date).format(
              constants.dateTimeFormat
            )
          : null;
      item.isFinalized = isNil(item.next_installments);
      item.total_amount = parsePrice(item.total_amount);
      item.remaining_amount = parsePrice(item.remaining_amount);
      item.upcomingInstallments = parsePrice(item.upcomingInstallments);

      return item;
    };
    return map(format)(data);
  }
}

export default LoansPageTransform;



// WEBPACK FOOTER //
// ./src/pages/loans/loans.transforms.js